import React from "react";
import TranslateText from "../TranslateText";
import BaseButton from "../Button/BaseButton";
import "../../../assets/style/modalStyle/previewProduct.scss";
import { formatPrice } from "../../../utils/functionCommon";
import { Tooltip } from "antd";
const ItemProductPreview = ({ data }) => {
  return (
    <div className="wrapperItemPreview">
      <div className="imgProduct">
        <img src={`${window.SERVER_URL}/${data.urlImage}`} alt={data.name} />
        {/* <img src={imgTesst} alt={data.name} /> */}
        {!data.status ? (
          <div className="outOfStock">
            <span>
              <TranslateText text={"Hết hàng"} />
            </span>
          </div>
        ) : null}
      </div>
      <h2 className="nameProduct">{data.name}</h2>
      <hr />
      <span className="priceDrop">
        <span>
          <TranslateText text={"Giá bán"} />:
        </span>
        <span>
          {" "}
          {formatPrice(data.priceDrop ? data.priceDrop : data.price)}
        </span>
      </span>
      <span
        className={`cost ${
          data.price && !data.priceDrop ? "descriptions" : null
        }`}
      >
        <Tooltip
          placement="topLeft"
          title={
            data.price && data.priceDrop
              ? formatPrice(data.price)
              : data.price && !data.priceDrop
              ? data.descriptions
              : null
          }
        >
          {data.price && data.priceDrop
            ? formatPrice(data.price)
            : data.price && !data.priceDrop
            ? data.descriptions
            : null}
        </Tooltip>
      </span>
      <div className="btnOrder">
        {data.typeButton === 2 ? (
          <BaseButton
            width={95}
            disabled={true}
            typeBtn={data.status ? "btnOrange" : "btnGray"}
            content={"LIÊN HỆ"}
          />
        ) : (
          <BaseButton
            width={95}
            disabled={true}
            typeBtn={data.status ? "btnOrange" : "btnGray"}
            content={"ĐẶT MUA"}
          />
        )}
      </div>
    </div>
  );
};

export default ItemProductPreview;
